import React, { useEffect } from 'react'
import { useState } from 'react';
import Tracking from './tracking';
import BulkTracking from './bulktracking';
import { valdiatePage } from '../../global';
import { useHistory } from 'react-router';

const TrackingTabs = (props) => {
    const history = useHistory();
    const [isDefault, setIsDefault] = useState(false)

    const myWorker = React.useRef(new Worker('./trackingbulkwebworker.js'));
    let worker = myWorker.current;

    useEffect(() => {
        if (!worker) {
            worker = new Worker('./trackingbulkwebworker.js')
        }
        return () => {
            worker.terminate();
            worker = null;
        }
    }, [])

    useEffect(() => {
        if (!valdiatePage('/tracking_2')) {
            history.push('/login');
        }
    }, []);

    return <section className="section">
        <div className="section-header">
            <ul className="nav nav-tabs">
                <li className="nav-item" onClick={() => setIsDefault(false)}><a className={`nav-link ${isDefault ? '' : 'active'}`} href="#"><h1 style={{ color: `${isDefault ? '' : '#e25a0c'}` }}>Tracking</h1></a></li>
                <li className="nav-item" onClick={() => setIsDefault(true)}><a className={`nav-link ${isDefault ? 'active' : ''}`} href="#"><h1 style={{ color: `${isDefault ? '#e25a0c' : ''}` }}>Bulk Tracking</h1></a></li>
            </ul>
        </div>

        {isDefault ? <BulkTracking  setIsDefault={() => setIsDefault(false)} myWorker={worker}/> : <Tracking props={props}/>}
    </section>
}

export default TrackingTabs;